import React, { useState } from 'react';
import Faq from './Faq';
import(`./styles/${window.__litium.themeName}.scss`);

const FaqContainer = ({ items, type = 'default' }) => {
  return (
    <div className={`faq-block faq-block--${type}`}>
      {items.length > 0 &&
        items.map((item, i) => <Faq key={'faqitem-' + i} {...item} />)}
    </div>
  );
};

export default FaqContainer;
